export const en_analytics = {
  analytics: 'Analytics',
  selectAll: 'Select All',
  chats: 'Chats',
  visits: 'Visits',
  close: 'Close',
  print: 'Print',
  applyToAll: 'Apply to All',
  nonFilteredGraphs: 'Non-Filtered Graphs',
  noUsersAvailable: 'No users are available',
  noData_Available: 'No data available',
  dataBeingFetched: 'Please wait, Data is being fetched...',
  lastHours: 'Last 24 Hours',
  lastDays: 'Last 30 Days',
  lastMonths: 'Last 6 Months',
  pleaseWait: 'Please wait, Data is being fetched...',
  addMore: 'Add More',
  customize: 'Customization',
  forThePastYear: 'For the Past Year',
  quickStatsLegendTextFor6Months:
    ' 6 months data comparison with previous 6 months is currently unavailable.',
  chatsLeads: 'Chats vs Leads',
  featuresUsage: 'Features Usage',
  chatReferrals: 'Chat Referrals',
  chatStatsBy: 'Chat Stats By',
  accountsActivation: 'Accounts Activation',
  topBottomLeadAccounts: 'Lead Accounts',
  topInactiveBillers: 'Top Inactive Billers',
  budgetPacing: 'Budget/Pacing',
  agentImages: 'Agent Images CTR',
  agentCTR: 'Agent CTR',
  accounts: 'Accounts',
  filters: 'Filters',
  clearAll: 'Clear All',
  clear: 'Clear',
  features: 'Features',
  devices: 'Devices',
  user: 'User',
  companyKey: 'Company Key(s)',
  typeOfBusiness: 'Types of business',
  ChartsShowHide: 'Charts Show/Hide',
  applyFilters: 'Apply Filters',
  apply: 'Apply',
  totalVisits: 'Total Visits',
  totalChats: 'Total Chats',
  totalLeads: 'Total Leads',
  totalBillableLeads: 'Total Billable Leads',
  clickThroughRate: 'Click Through Rate',
  leadConversionRate: 'Lead Conversion Rate',
  blankChats: 'Blank Chats',
  activeCallConnect: 'Active Call Connects',
  callConnectAttempts: 'Call Connect Attempts',
  callConnectDuration: 'Call Connect Duration (minutes)',
  activeChatsForHosts: 'Active Chats for Hosts',
  activeChats: 'Active Chats',
  ctr: 'CTR',
  lcr: 'LCR',
  signedRetainers: 'Signed Retainers',
  ringTimeThirty: 'in 30 seconds',
  ringTimeSixty: 'in 60 seconds',
  ringTimeNinety: 'in 90 seconds',
  totalDocumentSignedLeads: 'Signed Retainers',
  topLeadGenerators: 'Top Lead Generators',
  topRevenuePerClient: 'Top Revenue Per Client',
  filterApplied: 'Filters Applied',
  quickStats: 'Quick Stats',
  outboundCalls: 'Outbound Calls',
  callRecordings: 'Call Recordings',
  voiceleads: 'Voice Leads',
  voice: 'Voice',
  VoiceAgents: 'Voice Agents',
  businessConnectlabel: 'Summarized the call after business connect',
  livestats: 'Live Stats',
  responseTimeViaChat: 'Response Time Via Chat',
  avgAbandonedTime: 'Avg Abandonment Time',
  agentsOnline: 'Agents Online',
  activeCalls: 'Active Calls',
  callQualityTrends: 'Call Quality Trends',
  totalCallsGenerated: 'Total Number of Calls Generated',
  retainersOverview: 'Retainers Overview',
  peakVolumeTimes: 'Peak Volume Times',
  inboundCalls: 'Inbound Calls',
  avgTalkTime: 'Avg Call Duration',
  avgRingTime: 'Avg Answer Time',
  retainerSigned: 'Retainers Signed',
  retainerSigning: 'Retainer Signing',
  charts: 'Charts',
  label1: 'Last 30 days',
  label2: 'Increase from previous 30 days',
  label3: 'Decrease from previous 30 days',
  label4: 'In the',
  label5: 'Percentage',
  label6: 'Increases from the',
  label7: 'Decreases from the',
  startTour: {
    label: 'Start tour'
  },
  tourIntro1: 'This is start of analytics page and its Quick stats widgets',
  tourIntro2: 'Graphs..',
  tourIntro3: 'Total visits..',
  tourIntro4: 'Total Chats..',
  tourIntro5: 'Total Leads..',
  tourIntro6: 'Total Billable Leads..',
  tourIntro7: 'Click Through Rate..',
  tourIntro8: 'Lead Conversion Rate..',
  tooltip1:
    'The below charts/graphs are not filtered by any available filters like feature, user, devices, etc.',
  filtersTooltip1: ' Changes in this section are applied to:',
  homeBannerHeading:
    'Never miss a call with Blazeo Voice, our 24/7 call answering service.',
  homeBannerHeadingR: 'Never miss a call with our 24/7 call answering service.',
  homeBannerTextDirect:
    'Get valuable contacts with Google Business Profiles by our live chat agents at Blazeo (formerly ApexChat).',
  homeBannerText:
    'Our skilled agents can take a message, handle intake, qualification, call forwarding and routing as well as contract signing and appointment setting.',
  learnMore: 'Learn More',
  answeredIn20: 'Calls answered in < 20 secs',
  answeredIn30: 'Calls answered in < 30 secs',
  answeredAfter30: 'Calls answered in > 30 secs',
  inboundMinutes: 'Inbound Minutes',
  outboundMinutes: 'Outbound Minutes',
  retainerSent: 'Retainers Sent',
  retainerConversion: 'Retainer Conversion Rate',
  totalCalls: 'Total Calls',
  totalMinutes: 'Total Minutes',
  appointment: 'Appointments',
  appointmentBooked: 'Appointments Booked'
};
export default en_analytics;
export { default as fr_analytics } from '../fr-FR-AnalyticsDictionary/fr-analytics';
export { default as sp_analytics } from '../sp-SP-AnalyticsDictionary/sp-analytics';
